import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import EmailSelectorFamily, { EmailMode } from "../atoms/EmailAtom";

function useEmailEditorSubject(mode: EmailMode, index: number) {
  const [email, setEmail] = useRecoilState(
    EmailSelectorFamily({ mode, index })
  );
  const [subject, setSubject] = useState<string>(email.subject || "");

  const [splitSubject, setSplitSubject] = useState<string>(
    // HERE!
    // @ts-ignore
    email.splitSubject || ""
  );

  useEffect(() => {
    setSubject(email.subject);
  }, [email.subject]);

  useEffect(() => {
    // HERE!
    // @ts-ignore
    setSplitSubject(email.splitSubject);
    // HERE!
    // @ts-ignore
  }, [email.splitSubject]);

  const setEmailSubject: (value: string) => void = useCallback(
    debounce((value) => {
      setEmail((email) => ({ ...email, subject: value }));
    }, 100),
    [setEmail]
  );

  const setEmailSplitSubject: (value: string) => void = useCallback(
    debounce((value) => {
      setEmail((email) => ({ ...email, splitSubject: value }));
    }, 100),
    [setEmail]
  );

  const setSubjectCallback = (value) => {
    setSubject(value);
    setEmailSubject(value);
  };

  const setSplitSubjectCallback = (value) => {
    setSplitSubject(value);
    setEmailSplitSubject(value);
  };

  return { subject, splitSubject, setSubjectCallback, setSplitSubjectCallback };
}

export default useEmailEditorSubject;
